import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

window['CESIUM_BASE_URL'] = '/assets/cesium/';
Cesium.buildModuleUrl.setBaseUrl('/assets/cesium/');

Cesium.Ion.defaultAccessToken =
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmZmJmNWRlYy1lYzE4LTRlYWEtODc0Yy02NjM1ZDFkODVlNTciLCJpZCI6NDMwNDYsImlhdCI6MTYxMjE3NzYxNn0.o6WNLCw-WnKOF2qv3HmwnmeLcLOY3cyY6Cdk9RTFLeY';

import 'hammerjs';

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then((ref) => {
        // Ensure Angular destroys itself on hot reloads.
        if (window['ngRef']) {
            window['ngRef'].destroy();
        }
        window['ngRef'] = ref;

        // Otherwise, log the boot error
    })
    .catch((err) => console.error(err));
